/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Views_PinInputs */

const en_views_pin = /** @type {(inputs: Views_PinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pin ${i?.name} to the sidebar`)
};

const de_views_pin = /** @type {(inputs: Views_PinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} an die Seitenleiste heften`)
};

/**
* | output |
* | --- |
* | "Pin {name} to the sidebar" |
*
* @param {Views_PinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_pin = /** @type {((inputs: Views_PinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_PinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_pin(inputs)
	return en_views_pin(inputs)
});